import { EpisodeState } from "@/api/episodes-types";
import { pretty } from "@/utils/pretty";
import { blue, green, red } from "@mui/material/colors";
import { SyntheticEvent } from "react";
import { StateChip, StateChipProps } from "./StateChip";

type Props = {
  state: EpisodeState;
  size?: StateChipProps["size"];
  onDelete?: (event: SyntheticEvent) => void;
};

const colors = {
  accepted: green[500],
  rejected: red[500],
  textFailed: red[500],
  waitingForText: blue[500],
  pending: blue[500],
};

export function EpisodeStateChip({ state, size, onDelete }: Props) {
  return (
    <StateChip
      size={size}
      label={pretty(state, "capitalLetters")}
      color={colors[state]}
      onDelete={onDelete}
    />
  );
}
